import classnames from 'classnames/bind'
import React, { useRef } from 'react'

import { useTimeline } from '@unlikelystudio/react-hooks'

import Image, { ImageProps } from '~/components/Image'

import css from './styles.module.scss'

const cx = classnames.bind(css)
export type ImageWithPlaceholderProps = ImageProps
function ImageWithPlaceHolder({
  className,
  onLoad,
  ...rest
}: ImageWithPlaceholderProps) {
  const placeholderRef = useRef(null)
  const tl = useTimeline({ paused: true, restoreTime: true }, (tl) => {
    tl.fromTo(
      placeholderRef.current,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 0.3,
        ease: 'linear',
      },
    )
  })
  return (
    <div
      className={cx(css.ImageWithPlaceHolder, className)}
      ref={placeholderRef}>
      <Image {...rest} onLoadingComplete={() => tl.play()} />
    </div>
  )
}
ImageWithPlaceHolder.defaultProps = {}
export type { ImageProps } from '~/components/Image'
export default ImageWithPlaceHolder
